import { CometAdapter } from '#pplx/frontend/comet/client/adapter.js';
import { McpAdapter } from '#pplx/frontend/comet/client/mcpAdapter.js';
import { createZustandContext } from '#pplx/frontend/zustand-context/createZustandContext.js';
import { createContext, useContext } from 'react';
export const cometAdapter = new CometAdapter();
export const mcpAdapter = new McpAdapter(cometAdapter.getMobileProxy(), cometAdapter);
const cometContext = createZustandContext('CometContext', () => cometAdapter.getStore());
const entropyBrowserContext = createContext(undefined);
entropyBrowserContext.displayName = 'EntropyBrowserContext';
const mcpAdapterContext = createContext(undefined);
mcpAdapterContext.displayName = 'McpAdapterContext';
export function getCometProvider() {
    return cometContext.Provider;
}
export function getEntropyBrowserContext() {
    return entropyBrowserContext;
}
export function getMcpAdapterContext() {
    return mcpAdapterContext;
}
export function useEntropyBrowser(throwOnNullContext = true) {
    const context = useContext(entropyBrowserContext);
    if (!context && throwOnNullContext)
        throw new Error('useEntropyBrowser must be used inside EntropyBrowserProvider');
    return context;
}
export function useMcpAdapter(throwOnNullContext = true) {
    const context = useContext(mcpAdapterContext);
    if (!context && throwOnNullContext)
        throw new Error('useMcpAdapter must be used inside EntropyBrowserProvider');
    return context;
}
export const useCometState = cometContext.useTrackedState;
//# sourceMappingURL=EntropyBrowserHooks.js.map